<template>
  <JBottomSheet v-if="isMobile" v-model="internalModelValue" hasPopstate>
    <template #header>
      <div
        class="border-b border-gray-200 px-16 py-12 text-center text-pane-header font-bold"
      >
        {{ $t('affiliate.modalTitle') }}
      </div>
    </template>

    <AffiliateForm @cancel="toggleAffiliateModal" @confirm="onConfirm" />
  </JBottomSheet>

  <JModal
    v-else
    v-model="internalModelValue"
    :title="$t('affiliate.modalTitle')"
  >
    <AffiliateForm @cancel="toggleAffiliateModal" @confirm="onConfirm" />
  </JModal>
</template>

<script lang="ts" setup>
import { JBottomSheet, JModal, useDevicePlatform } from '@journey/ui-kit'
import { useVModel } from '@vueuse/core'
import type { Emits, Props } from './AffiliateModal.types'
import AffiliateForm from '@/modules/Affiliate/components/Form/AffiliateForm/AffiliateForm.vue'
import { useAffiliate } from '@/modules/Affiliate/composables'

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const internalModelValue = useVModel(props, 'modelValue', emit)

function toggleAffiliateModal() {
  internalModelValue.value = false
}

const { isMobile } = useDevicePlatform()

const { refetch } = useAffiliate()
function onConfirm() {
  refetch()
}
</script>
